import { render, staticRenderFns } from "./TagsPage.vue?vue&type=template&id=f0700a14&scoped=true&"
import script from "./TagsPage.vue?vue&type=script&lang=js&"
export * from "./TagsPage.vue?vue&type=script&lang=js&"
import style0 from "./TagsPage.vue?vue&type=style&index=0&id=f0700a14&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0700a14",
  null
  
)

export default component.exports